import React from 'react';
import classNames from 'classnames';

import { abandonCheckoutDraft } from '../../util/bookingIntent';

import NamedLink from '../NamedLink/NamedLink';

import Logo from './Logo';
import css from './LinkedLogo.module.css';

/**
 * Clickable marketplace logo. Always goes to the landing page.
 *
 * Console top-bar.json sometimes sets logoLink to `#`, a marketing host,
 * or the current checkout URL. Using that href on TEST left Pay looking
 * like a dead page — the mark did not navigate. Ignore hosted hrefs.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {string?} props.logoClassName andd more style rules in addtion to css.logo
 * @param {string?} props.logoImageClassName overwrite components own css.root
 * @param {('desktop' | 'mobile')} props.layout
 * @param {Object} [props.linkToExternalSite] ignored; kept so callers can still pass Console config
 * @param {string?} props.alt alt text for logo image
 * @returns {JSX.Element} linked logo component
 */
const LinkedLogo = props => {
  const {
    id,
    className,
    rootClassName,
    logoClassName,
    logoImageClassName,
    layout = 'desktop',
    linkToExternalSite: _ignoredLogoLink,
    alt,
    onClick,
    ...rest
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const goHome = event => {
    abandonCheckoutDraft();
    if (typeof onClick === 'function') {
      onClick(event);
    }
  };

  return (
    <NamedLink
      id={id}
      className={classes}
      name="LandingPage"
      title={alt}
      ariaLabel={alt}
      onClick={goHome}
      {...rest}
    >
      <Logo
        layout={layout}
        className={logoClassName}
        logoImageClassName={logoImageClassName}
        alt={alt}
      />
    </NamedLink>
  );
};

export default LinkedLogo;
